import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center">
            <h2>Oppss something Wrong</h2>
            <p className="text-danger">404 error!!!!!!!!!!</p>
        </div>
    );
};

export default NotFound;